import React, { useContext } from 'react';
import { UserGroupRules } from 'src/graphql/entities/group-rules/group-rules.types';
import type { SignalIncident } from 'src/graphql/entities/signal-incident/signal-incident.types';
import { useChatCommonData } from 'src/pages/Conversations/Chat/registry/common-data-context';
import { SignalIncidentContext } from './signal-incident-context';
import { SignalIncidentRowView } from './signal-incident-row-view';

export const SignalIncidentRow = React.memo(({ item }: { item: SignalIncident }) => {
  const { updatingId, resolve } = useContext(SignalIncidentContext)!;
  const canUpdate = useChatCommonData((s) =>
    Boolean(s.groupRules[UserGroupRules.AccessToResolveSignalIncident]),
  );

  return (
    <SignalIncidentRowView
      incident={item}
      canUpdateIncident={canUpdate}
      isUpdating={updatingId === item.signalIncidentId}
      onUpdateIncident={() => resolve(item)}
    />
  );
});
SignalIncidentRow.displayName = 'SignalIncidentRow';
